import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import get from 'lodash/get';
import OrderConfirmationSummary from './OrderConfirmationSummary';
import formatPrismicData from '../../hocs/formatPrismicData';
import withCountry from '../../hocs/withCountry';
import { withUserOrders } from '../../data-providers/orders';
import { withModel } from '../../data-providers/model';
import logger from '../../../../../logger';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  formatPrismicData,
  withUserOrders,
  withModel,
  withRouter,
  withCountry,
  withState('items', 'setItems', []),
  lifecycle({
    async componentDidMount() {
      const { props } = this;
      const orderNumber = props.match.params.orderNumber;
      try {
        const { order } = await props.fetchUserOrder(orderNumber);
        return order;
      } catch (err) {
        if (err.status === 401) {
          const localisedLogin = localiseUrl(props.country, '/login');
          const currentPath = window.location.pathname;
          const currentSearch = window.location.search;
          const currentUrl = `${currentPath}${currentSearch}`;
          logger.info('Auth redirect: orders/:orderNumber', currentPath);
          window.location = `${localisedLogin}?return_to=${currentUrl}`;
        };
        logger.error('Failed to fetch user order', err);
      }
    }
  }),
  withProps(props => {
    const translatedLabels = get(props, 'model.prismicGlobalContentModel.checkout');
    const values = get(props, 'userOrders.orders[0]') || {};
    const estimatedShipping = values.shipmentTotal;
    const discountedTotal = get(values, 'total', {});

    return {
      response: props.userOrders.response,
      summary: {
        totals_v2: {
          shipping_estimated: true,
        }
      },
      items: get(props, 'userOrders.orders[0]', []).items,
      values: {
        ...values,
        estimatedShipping,
        discountedTotal,
      },
      labels: {
        itemTotal: translatedLabels.subtotalLabel,
        discountedTotal: translatedLabels.totalLabel,
        estimatedShipping: translatedLabels.shippingLabel,
      },
    };
  })
);

export default enhance(OrderConfirmationSummary);



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderConfirmationSummary/index.js